import { AvatarWithInitials } from '@eluve/blocks';
import { Stack, Tag, Text } from '@eluve/components';
import { formatHumanName } from '@eluve/utils';

import { UserOptionInfo } from './utils';

export const UserOption: React.FC<UserOptionInfo> = (user) => {
  const name = formatHumanName(user.firstName, user.lastName);

  return (
    <Stack className="py-1" direction="horizontal" fullWidth={false} gap={4}>
      <AvatarWithInitials name={name} id={user.id} />
      <Stack className="flex-1" gap={2}>
        <Text weight="semibold" className="privacy-text">
          {name}
        </Text>
        {user.email && <Tag color="gray" label={user.email} size="xs" />}
      </Stack>
    </Stack>
  );
};
